<template>
  <!-- 海报html元素 -->
  <div id="posterHtml" :style="{backgroundImage: 'url('+posterHtmlBg+')'}">
    <div v-if="!posterImg" class="qrcodetitle">{{ title }}</div>
    <!-- 二维码 -->
    <div class="qrcode" v-if="!posterImg">
      <canvas id="qrcodeImg"></canvas>
      <div style="display: flex; gap: 10px">
        <div>{{ qrText }}</div>
        <a-button type="primary" @click="copy" size="small">复制</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode';
import html2canvas from 'html2canvas';

export default {
  name: 'Qrcode',
  props: ['title', 'qrText'],
  data() {
    return {
      posterContent: '站点编号：101008', // 文案内容
      posterHtmlBg: 'none',
      posterImg: '', // 最终生成的海报图片
    };
  },
  mounted() {
    this.createQrcode(this.qrText);
  },
  watch: {
    qrText() {
      this.createQrcode(this.qrText);
    },
  },
  methods: {
    createQrcode(text) {
      const canvas = document.getElementById('qrcodeImg');
      // const that = this;
      QRCode.toCanvas(
        canvas,
        text,
        {
          errorCorrectionLevel: 'H',
          margin: 1,
          width: 400,
          color: {
            dark: '#000',
            light: '#fff',
          },
        },
        (err) => {
          if (err) console.error(err);
          // that.createPoster();
        },
      );
    },
    copy() {
      const text = this.qrText;
      const input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand('Copy');
      document.body.removeChild(input);
      this.$message.success('复制成功');
    },
    createPoster() {
      const vm = this;
      const domObj = document.getElementById('posterHtml');
      html2canvas(domObj, {
        useCORS: true,
        allowTaint: false,
        logging: false,
        letterRendering: true,
        onclone(doc) {
          const e = doc.querySelector('#posterHtml');
          e.style.display = 'block';
        },
      }).then((canvas) => {
        // 在微信里,可长按保存或转发
        vm.posterHtmlBg = '';
        vm.posterImg = canvas.toDataURL('image/png');
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.qrcodetitle{
  font-size: 30px;
  position: absolute;
  right:50%;
  bottom: 0;
  transform: translate3d(50%, -20px, 0);
}
#posterHtml {
  height: 100%;
  width: 100%;
  background-size: 100% 100%;
  position: relative;
}
.qrcode {
  position: absolute;
  bottom: 50%;
  right:50%;
  transform: translate3d(50%, 50%, 0);
}
.poster {
  width: 100%;
  height: 100%;
}
</style>
